import { render, staticRenderFns } from "./PublicDisplayConfigCard.vue?vue&type=template&id=f3ba6056&scoped=true"
import script from "./PublicDisplayConfigCard.vue?vue&type=script&lang=js"
export * from "./PublicDisplayConfigCard.vue?vue&type=script&lang=js"
import style0 from "./PublicDisplayConfigCard.vue?vue&type=style&index=0&id=f3ba6056&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba6056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ba6056')) {
      api.createRecord('f3ba6056', component.options)
    } else {
      api.reload('f3ba6056', component.options)
    }
    module.hot.accept("./PublicDisplayConfigCard.vue?vue&type=template&id=f3ba6056&scoped=true", function () {
      api.rerender('f3ba6056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/PublicDisplayConfigCard.vue"
export default component.exports